// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Address from "./address.js"
import BankAccount from "./bank-account.js"
import ContactAddress from "./contact-address.js"
import ContactRelationship from "./contact-relationship.js"
import Email from "./email.js"
import Organization from "./organization.js"
import Person from "./person.js"
import PhoneNumber from "./phone-number.js"
import SchoolYear from "./school-year.js"
import StudentCouncil from "./student-council.js"
import Subscription from "./subscription.js"
import Supplier from "./supplier.js"
import Tenant from "./tenant.js"
import User from "./user.js"

const modelClassData = {
  "attributes": {
    "anonymize": {
      "column": {
        "default": false,
        "name": "anonymize",
        "null": false,
        "type": "boolean"
      },
      "name": "anonymize",
      "selected_by_default": null,
      "translated": null
    },
    "anonymize_at": {
      "column": {
        "default": null,
        "name": "anonymize_at",
        "null": true,
        "type": "date"
      },
      "name": "anonymize_at",
      "selected_by_default": null,
      "translated": null
    },
    "contact_type": {
      "column": {
        "default": null,
        "name": "contact_type",
        "null": false,
        "type": "string"
      },
      "name": "contact_type",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "deleted_at": {
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      },
      "name": "deleted_at",
      "selected_by_default": null,
      "translated": null
    },
    "finance_dimension_value_id": {
      "column": {
        "default": null,
        "name": "finance_dimension_value_id",
        "null": true,
        "type": "uuid"
      },
      "name": "finance_dimension_value_id",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": true,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "organization_id": {
      "column": {
        "default": null,
        "name": "organization_id",
        "null": true,
        "type": "uuid"
      },
      "name": "organization_id",
      "selected_by_default": null,
      "translated": null
    },
    "person_id": {
      "column": {
        "default": null,
        "name": "person_id",
        "null": true,
        "type": "uuid"
      },
      "name": "person_id",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": "not_approved",
        "name": "state",
        "null": false,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    },
    "tenant_id": {
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      },
      "name": "tenant_id",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "billing_contact_id": {
      "column": {
        "default": null,
        "name": "billing_contact_id",
        "null": true,
        "type": "uuid"
      },
      "name": "billing_contact_id",
      "selected_by_default": false,
      "translated": null
    },
    "debtor_account_number": {
      "column": {
        "default": null,
        "name": "debtor_account_number",
        "null": true,
        "type": "string"
      },
      "name": "debtor_account_number",
      "selected_by_default": false,
      "translated": null
    },
    "debtor_contact_name": {
      "column": {
        "default": null,
        "name": "debtor_contact_name",
        "null": true,
        "type": "string"
      },
      "name": "debtor_contact_name",
      "selected_by_default": false,
      "translated": null
    },
    "imported_from_old_nemoa": {
      "column": {
        "default": false,
        "name": "imported_from_old_nemoa",
        "null": false,
        "type": "boolean"
      },
      "name": "imported_from_old_nemoa",
      "selected_by_default": false,
      "translated": null
    },
    "nemoa_old_contact_id": {
      "column": {
        "default": null,
        "name": "nemoa_old_contact_id",
        "null": true,
        "type": "integer"
      },
      "name": "nemoa_old_contact_id",
      "selected_by_default": false,
      "translated": null
    },
    "nemoa_old_created_at": {
      "column": {
        "default": null,
        "name": "nemoa_old_created_at",
        "null": true,
        "type": "datetime"
      },
      "name": "nemoa_old_created_at",
      "selected_by_default": false,
      "translated": null
    },
    "nemoa_old_global_id": {
      "column": {
        "default": null,
        "name": "nemoa_old_global_id",
        "null": true,
        "type": "integer"
      },
      "name": "nemoa_old_global_id",
      "selected_by_default": false,
      "translated": null
    },
    "p_number": {
      "column": {
        "default": null,
        "name": "p_number",
        "null": true,
        "type": "integer"
      },
      "name": "p_number",
      "selected_by_default": false,
      "translated": null
    },
    "p_number_with_fallback": {
      "column": null,
      "name": "p_number_with_fallback",
      "selected_by_default": false,
      "translated": null
    },
    "departments_with_ancestors": {
      "column": null,
      "name": "departments_with_ancestors",
      "selected_by_default": false,
      "translated": null
    },
    "translated_contact_type": {
      "column": null,
      "name": "translated_contact_type",
      "selected_by_default": false,
      "translated": null
    },
    "translated_state": {
      "column": null,
      "name": "translated_state",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "Contact",
  "collectionKey": "contacts",
  "collectionName": "contacts",
  "i18nKey": "contact",
  "camelizedLower": "contact",
  "name": "Contact",
  "nameDasherized": "contact",
  "pluralName": "contacts",
  "ransackable_associations": [
    {
      "className": "ActivityParticipant",
      "collectionName": "activity_participants",
      "foreignKey": "contact_id",
      "name": "activity_participants",
      "macro": "has_many",
      "resource_name": "ActivityParticipant",
      "through": null
    },
    {
      "className": "Address",
      "collectionName": "addresses",
      "foreignKey": "address_id",
      "name": "addresses",
      "macro": "has_many",
      "resource_name": "Address",
      "through": "contact_addresses"
    },
    {
      "className": "AgendaItemElementSpeaker",
      "collectionName": "agenda_item_element_speakers",
      "foreignKey": "contact_id",
      "name": "agenda_item_element_speakers",
      "macro": "has_many",
      "resource_name": "AgendaItemElementSpeaker",
      "through": null
    },
    {
      "className": "BankAccount",
      "collectionName": "bank_accounts",
      "foreignKey": "contact_id",
      "name": "bank_accounts",
      "macro": "has_many",
      "resource_name": "BankAccount",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "billing_contact_id",
      "name": "billing_contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "CallListEntity",
      "collectionName": "call_list_entities",
      "foreignKey": "contact_id",
      "name": "call_list_entities",
      "macro": "has_many",
      "resource_name": "CallListEntity",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "child_id",
      "name": "children",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "children_relationships"
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "parent_id",
      "name": "children_relationships",
      "macro": "has_many",
      "resource_name": "ContactRelationship",
      "through": null
    },
    {
      "className": "ClassStep",
      "collectionName": "class_steps",
      "foreignKey": "class_step_id",
      "name": "class_step",
      "macro": "has_one",
      "resource_name": "ClassStep",
      "through": "current_school_year"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "parent_id",
      "name": "commune",
      "macro": "has_one",
      "resource_name": "Contact",
      "through": "commune_relationship"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "child_id",
      "name": "commune_for",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "commune_for_relationships"
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "parent_id",
      "name": "commune_for_relationships",
      "macro": "has_many",
      "resource_name": "ContactRelationship",
      "through": null
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "child_id",
      "name": "commune_relationship",
      "macro": "has_one",
      "resource_name": "ContactRelationship",
      "through": null
    },
    {
      "className": "Competition",
      "collectionName": "competitions",
      "foreignKey": "competition_id",
      "name": "competitions",
      "macro": "has_many",
      "resource_name": "Competition",
      "through": "teams"
    },
    {
      "className": "ContactAddress",
      "collectionName": "contact_addresses",
      "foreignKey": "contact_id",
      "name": "contact_addresses",
      "macro": "has_many",
      "resource_name": "ContactAddress",
      "through": null
    },
    {
      "className": "ContactGroupContact",
      "collectionName": "contact_group_contacts",
      "foreignKey": "contact_id",
      "name": "contact_group_contacts",
      "macro": "has_many",
      "resource_name": "ContactGroupContact",
      "through": null
    },
    {
      "className": "ContactGroup",
      "collectionName": "contact_groups",
      "foreignKey": "contact_group_id",
      "name": "contact_groups",
      "macro": "has_many",
      "resource_name": "ContactGroup",
      "through": "contact_group_contacts"
    },
    {
      "className": "ContactPhotoSessionCurrent",
      "collectionName": "contact_photo_session_currents",
      "foreignKey": "contact_id",
      "name": "contact_photo_session_currents",
      "macro": "has_many",
      "resource_name": "ContactPhotoSessionCurrent",
      "through": null
    },
    {
      "className": "Conversation",
      "collectionName": "conversations",
      "foreignKey": "contact_id",
      "name": "conversations",
      "macro": "has_many",
      "resource_name": "Conversation",
      "through": null
    },
    {
      "className": "SchoolYear",
      "collectionName": "school_years",
      "foreignKey": "contact_id",
      "name": "current_school_year",
      "macro": "has_one",
      "resource_name": "SchoolYear",
      "through": null
    },
    {
      "className": "SchoolYear",
      "collectionName": "school_years",
      "foreignKey": "contact_id",
      "name": "current_school_years",
      "macro": "has_many",
      "resource_name": "SchoolYear",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "child_id",
      "name": "department_for",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "department_for_relationships"
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "parent_id",
      "name": "department_for_relationships",
      "macro": "has_many",
      "resource_name": "ContactRelationship",
      "through": null
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "child_id",
      "name": "department_relationships",
      "macro": "has_many",
      "resource_name": "ContactRelationship",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "parent_id",
      "name": "departments",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "department_relationships"
    },
    {
      "className": "ElectionPostContact",
      "collectionName": "election_post_contacts",
      "foreignKey": "contact_id",
      "name": "election_post_contacts",
      "macro": "has_many",
      "resource_name": "ElectionPostContact",
      "through": null
    },
    {
      "className": "Email",
      "collectionName": "emails",
      "foreignKey": "contact_id",
      "name": "emails",
      "macro": "has_many",
      "resource_name": "Email",
      "through": null
    },
    {
      "className": "EmployeePrice",
      "collectionName": "employee_prices",
      "foreignKey": "contact_id",
      "name": "employee_prices",
      "macro": "has_many",
      "resource_name": "EmployeePrice",
      "through": null
    },
    {
      "className": "FinanceDimensionValue",
      "collectionName": "finance_dimension_values",
      "foreignKey": "finance_dimension_value_id",
      "name": "finance_dimension_value",
      "macro": "belongs_to",
      "resource_name": "FinanceDimensionValue",
      "through": null
    },
    {
      "className": "Highscore",
      "collectionName": "highscores",
      "foreignKey": "highscore_id",
      "name": "highscores",
      "macro": "has_many",
      "resource_name": "Highscore",
      "through": "teams"
    },
    {
      "className": "Invoice",
      "collectionName": "invoices",
      "foreignKey": "contact_id",
      "name": "invoices",
      "macro": "has_many",
      "resource_name": "Invoice",
      "through": null
    },
    {
      "className": "Invoice",
      "collectionName": "invoices",
      "foreignKey": "concerning_id",
      "name": "invoices_concerning",
      "macro": "has_many",
      "resource_name": "Invoice",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "child_id",
      "name": "joint_student_council",
      "macro": "has_one",
      "resource_name": "Contact",
      "through": "joint_student_council_relationship"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "parent_id",
      "name": "joint_student_council_for",
      "macro": "has_one",
      "resource_name": "Contact",
      "through": "joint_student_council_for_relationship"
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "child_id",
      "name": "joint_student_council_for_relationship",
      "macro": "has_one",
      "resource_name": "ContactRelationship",
      "through": null
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "parent_id",
      "name": "joint_student_council_relationship",
      "macro": "has_one",
      "resource_name": "ContactRelationship",
      "through": null
    },
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "location_id",
      "name": "location_on_activities",
      "macro": "has_many",
      "resource_name": "Activity",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "MessageRecipient",
      "collectionName": "message_recipients",
      "foreignKey": "contact_id",
      "name": "message_recipients",
      "macro": "has_many",
      "resource_name": "MessageRecipient",
      "through": null
    },
    {
      "className": "Message",
      "collectionName": "messages",
      "foreignKey": "message_id",
      "name": "messages",
      "macro": "has_many",
      "resource_name": "Message",
      "through": "message_recipients"
    },
    {
      "className": "Navigation",
      "collectionName": "navigations",
      "foreignKey": "contact_id",
      "name": "navigations",
      "macro": "has_many",
      "resource_name": "Navigation",
      "through": null
    },
    {
      "className": "Notification",
      "collectionName": "notifications",
      "foreignKey": "contact_id",
      "name": "notifications",
      "macro": "has_many",
      "resource_name": "Notification",
      "through": null
    },
    {
      "className": "Order",
      "collectionName": "orders",
      "foreignKey": "customer_id",
      "name": "orders",
      "macro": "has_many",
      "resource_name": "Order",
      "through": null
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "organization_id",
      "name": "organization",
      "macro": "belongs_to",
      "resource_name": "Organization",
      "through": null
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "child_id",
      "name": "parent_relationships",
      "macro": "has_many",
      "resource_name": "ContactRelationship",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "parent_id",
      "name": "parents",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "parent_relationships"
    },
    {
      "className": "Person",
      "collectionName": "people",
      "foreignKey": "person_id",
      "name": "person",
      "macro": "belongs_to",
      "resource_name": "Person",
      "through": null
    },
    {
      "className": "PhoneNumber",
      "collectionName": "phone_numbers",
      "foreignKey": "contact_id",
      "name": "phone_numbers",
      "macro": "has_many",
      "resource_name": "PhoneNumber",
      "through": null
    },
    {
      "className": "PhotoSessionGroupContactTokenContact",
      "collectionName": "photo_session_group_contact_token_contacts",
      "foreignKey": "contact_id",
      "name": "photo_session_group_contact_token_contacts",
      "macro": "has_many",
      "resource_name": "PhotoSessionGroupContactTokenContact",
      "through": null
    },
    {
      "className": "PhotoSessionGroupContact",
      "collectionName": "photo_session_group_contacts",
      "foreignKey": "contact_id",
      "name": "photo_session_group_contacts",
      "macro": "has_many",
      "resource_name": "PhotoSessionGroupContact",
      "through": null
    },
    {
      "className": "PhotoSession",
      "collectionName": "photo_sessions",
      "foreignKey": "customer_id",
      "name": "photo_sessions",
      "macro": "has_many",
      "resource_name": "PhotoSession",
      "through": null
    },
    {
      "className": "Photo",
      "collectionName": "photos",
      "foreignKey": "uploaded_by_id",
      "name": "photos",
      "macro": "has_many",
      "resource_name": "Photo",
      "through": null
    },
    {
      "className": "Address",
      "collectionName": "addresses",
      "foreignKey": "address_id",
      "name": "primary_address",
      "macro": "has_one",
      "resource_name": "Address",
      "through": "primary_contact_address"
    },
    {
      "className": "BankAccount",
      "collectionName": "bank_accounts",
      "foreignKey": "contact_id",
      "name": "primary_bank_account",
      "macro": "has_one",
      "resource_name": "BankAccount",
      "through": null
    },
    {
      "className": "ContactAddress",
      "collectionName": "contact_addresses",
      "foreignKey": "contact_id",
      "name": "primary_contact_address",
      "macro": "has_one",
      "resource_name": "ContactAddress",
      "through": null
    },
    {
      "className": "Email",
      "collectionName": "emails",
      "foreignKey": "contact_id",
      "name": "primary_email",
      "macro": "has_one",
      "resource_name": "Email",
      "through": null
    },
    {
      "className": "PhoneNumber",
      "collectionName": "phone_numbers",
      "foreignKey": "contact_id",
      "name": "primary_phone_number",
      "macro": "has_one",
      "resource_name": "PhoneNumber",
      "through": null
    },
    {
      "className": "Order",
      "collectionName": "orders",
      "foreignKey": "process_contact_id",
      "name": "process_orders",
      "macro": "has_many",
      "resource_name": "Order",
      "through": null
    },
    {
      "className": "ProposalContact",
      "collectionName": null,
      "foreignKey": "contact_id",
      "name": "proposal_contacts",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "ProposalVoteToken",
      "collectionName": "proposal_vote_tokens",
      "foreignKey": "contact_id",
      "name": "proposal_vote_tokens",
      "macro": "has_many",
      "resource_name": "ProposalVoteToken",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "parent_id",
      "name": "region",
      "macro": "has_one",
      "resource_name": "Contact",
      "through": "region_relationship"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "child_id",
      "name": "region_for",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "region_for_relationships"
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "parent_id",
      "name": "region_for_relationships",
      "macro": "has_many",
      "resource_name": "ContactRelationship",
      "through": null
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "child_id",
      "name": "region_relationship",
      "macro": "has_one",
      "resource_name": "ContactRelationship",
      "through": null
    },
    {
      "className": "Reimbursement",
      "collectionName": "reimbursements",
      "foreignKey": "contact_id",
      "name": "reimbursements",
      "macro": "has_many",
      "resource_name": "Reimbursement",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "parent_id",
      "name": "relative_for",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "relative_for_relationships"
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "child_id",
      "name": "relative_for_relationships",
      "macro": "has_many",
      "resource_name": "ContactRelationship",
      "through": null
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "parent_id",
      "name": "relative_relationships",
      "macro": "has_many",
      "resource_name": "ContactRelationship",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "child_id",
      "name": "relatives",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "relative_relationships"
    },
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "responsible_id",
      "name": "responsible_on_activities",
      "macro": "has_many",
      "resource_name": "Activity",
      "through": null
    },
    {
      "className": "Conversation",
      "collectionName": "conversations",
      "foreignKey": "responsible_id",
      "name": "responsible_on_conversations",
      "macro": "has_many",
      "resource_name": "Conversation",
      "through": null
    },
    {
      "className": "Role",
      "collectionName": "roles",
      "foreignKey": "role_id",
      "name": "roles",
      "macro": "has_many",
      "resource_name": "Role",
      "through": "person"
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "school_id",
      "name": "school",
      "macro": "has_one",
      "resource_name": "Organization",
      "through": "current_school_year"
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "school_class_id",
      "name": "school_class",
      "macro": "has_one",
      "resource_name": "SchoolClass",
      "through": "current_school_year"
    },
    {
      "className": "SchoolYear",
      "collectionName": "school_years",
      "foreignKey": "contact_id",
      "name": "school_years",
      "macro": "has_many",
      "resource_name": "SchoolYear",
      "through": null
    },
    {
      "className": "ContactMergeRequest",
      "collectionName": "contact_merge_requests",
      "foreignKey": "source_contact_id",
      "name": "source_contact_on_contact_merge_requests",
      "macro": "has_many",
      "resource_name": "ContactMergeRequest",
      "through": null
    },
    {
      "className": "StudentCouncil",
      "collectionName": "student_councils",
      "foreignKey": "student_council_id",
      "name": "student_council",
      "macro": "belongs_to",
      "resource_name": "StudentCouncil",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "parent_id",
      "name": "student_council_for",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "student_council_for_relationships"
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "child_id",
      "name": "student_council_for_relationships",
      "macro": "has_many",
      "resource_name": "ContactRelationship",
      "through": null
    },
    {
      "className": "StudentCouncilMembership",
      "collectionName": "student_council_memberships",
      "foreignKey": "organization_id",
      "name": "student_council_memberships",
      "macro": "has_many",
      "resource_name": "StudentCouncilMembership",
      "through": "organization"
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "parent_id",
      "name": "student_council_relationships",
      "macro": "has_many",
      "resource_name": "ContactRelationship",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "child_id",
      "name": "student_councils",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "student_council_relationships"
    },
    {
      "className": "Subscription",
      "collectionName": "subscriptions",
      "foreignKey": "contact_id",
      "name": "subscriptions",
      "macro": "has_many",
      "resource_name": "Subscription",
      "through": null
    },
    {
      "className": "Supplier",
      "collectionName": "suppliers",
      "foreignKey": "supplier_id",
      "name": "supplier",
      "macro": "belongs_to",
      "resource_name": "Supplier",
      "through": null
    },
    {
      "className": "SurveyJudge",
      "collectionName": "survey_judges",
      "foreignKey": "contact_id",
      "name": "survey_judges",
      "macro": "has_many",
      "resource_name": "SurveyJudge",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "ContactMergeRequest",
      "collectionName": "contact_merge_requests",
      "foreignKey": "target_contact_id",
      "name": "target_contact_on_contact_merge_requests",
      "macro": "has_many",
      "resource_name": "ContactMergeRequest",
      "through": null
    },
    {
      "className": "TeamUser",
      "collectionName": "team_users",
      "foreignKey": "user_id",
      "name": "team_users",
      "macro": "has_many",
      "resource_name": "TeamUser",
      "through": "user"
    },
    {
      "className": "Team",
      "collectionName": "teams",
      "foreignKey": "team_id",
      "name": "teams",
      "macro": "has_many",
      "resource_name": "Team",
      "through": "team_users"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "person_id",
      "name": "user",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "VoteToken",
      "collectionName": "vote_tokens",
      "foreignKey": "contact_id",
      "name": "vote_tokens",
      "macro": "has_many",
      "resource_name": "VoteToken",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "anonymize",
      "column": {
        "default": false,
        "name": "anonymize",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "anonymize_at",
      "column": {
        "default": null,
        "name": "anonymize_at",
        "null": true,
        "type": "date"
      }
    },
    {
      "name": "anonymized_at",
      "column": {
        "default": null,
        "name": "anonymized_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "billing_contact_id",
      "column": {
        "default": null,
        "name": "billing_contact_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "contact_type",
      "column": {
        "default": null,
        "name": "contact_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "debtor_account_number",
      "column": {
        "default": null,
        "name": "debtor_account_number",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "debtor_contact_name",
      "column": {
        "default": null,
        "name": "debtor_contact_name",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "deleted_at",
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "finance_dimension_value_id",
      "column": {
        "default": null,
        "name": "finance_dimension_value_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "imported_from_old_nemoa",
      "column": {
        "default": false,
        "name": "imported_from_old_nemoa",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "nemoa_old_contact_id",
      "column": {
        "default": null,
        "name": "nemoa_old_contact_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "nemoa_old_created_at",
      "column": {
        "default": null,
        "name": "nemoa_old_created_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "nemoa_old_global_id",
      "column": {
        "default": null,
        "name": "nemoa_old_global_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_billing_contact_id",
      "column": {
        "default": null,
        "name": "old_billing_contact_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_finance_dimension_value_id",
      "column": {
        "default": null,
        "name": "old_finance_dimension_value_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_organization_id",
      "column": {
        "default": null,
        "name": "old_organization_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_person_id",
      "column": {
        "default": null,
        "name": "old_person_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_student_council_id",
      "column": {
        "default": null,
        "name": "old_student_council_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "organization_id",
      "column": {
        "default": null,
        "name": "organization_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "p_number",
      "column": {
        "default": null,
        "name": "p_number",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "person_id",
      "column": {
        "default": null,
        "name": "person_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "phone_numbers_count",
      "column": {
        "default": 0,
        "name": "phone_numbers_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "state",
      "column": {
        "default": "not_approved",
        "name": "state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "student_council_id",
      "column": {
        "default": null,
        "name": "student_council_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "supplier_id",
      "column": {
        "default": null,
        "name": "supplier_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "index_search"
    },
    {
      "name": "not_anonymous"
    },
    {
      "name": "not_disabled_active_code_or_null"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    },
    {
      "name": "with_active_student_council_subscription"
    },
    {
      "name": "with_commune_id_in"
    },
    {
      "name": "with_region_id_in"
    },
    {
      "name": "with_relation_to_department_nested"
    },
    {
      "name": "with_same_email"
    },
    {
      "name": "with_same_phone_number"
    },
    {
      "name": "without_active_student_council_subscription"
    }
  ],
  "relationships": [
    {
      "className": "Address",
      "collectionName": "addresses",
      "foreignKey": "address_id",
      "name": "addresses",
      "macro": "has_many",
      "resource_name": "Address",
      "through": "contact_addresses"
    },
    {
      "className": "BankAccount",
      "collectionName": "bank_accounts",
      "foreignKey": "contact_id",
      "name": "bank_accounts",
      "macro": "has_many",
      "resource_name": "BankAccount",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "child_id",
      "name": "children",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "children_relationships"
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "parent_id",
      "name": "children_relationships",
      "macro": "has_many",
      "resource_name": "ContactRelationship",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "parent_id",
      "name": "commune",
      "macro": "has_one",
      "resource_name": "Contact",
      "through": "commune_relationship"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "child_id",
      "name": "commune_for",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "commune_for_relationships"
    },
    {
      "className": "ContactAddress",
      "collectionName": "contact_addresses",
      "foreignKey": "contact_id",
      "name": "contact_addresses",
      "macro": "has_many",
      "resource_name": "ContactAddress",
      "through": null
    },
    {
      "className": "SchoolYear",
      "collectionName": "school_years",
      "foreignKey": "contact_id",
      "name": "current_school_year",
      "macro": "has_one",
      "resource_name": "SchoolYear",
      "through": null
    },
    {
      "className": "Email",
      "collectionName": "emails",
      "foreignKey": "contact_id",
      "name": "emails",
      "macro": "has_many",
      "resource_name": "Email",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "child_id",
      "name": "joint_student_council",
      "macro": "has_one",
      "resource_name": "Contact",
      "through": "joint_student_council_relationship"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "parent_id",
      "name": "joint_student_council_for",
      "macro": "has_one",
      "resource_name": "Contact",
      "through": "joint_student_council_for_relationship"
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "organization_id",
      "name": "organization",
      "macro": "belongs_to",
      "resource_name": "Organization",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "parent_id",
      "name": "parents",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "parent_relationships"
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "child_id",
      "name": "parent_relationships",
      "macro": "has_many",
      "resource_name": "ContactRelationship",
      "through": null
    },
    {
      "className": "Person",
      "collectionName": "people",
      "foreignKey": "person_id",
      "name": "person",
      "macro": "belongs_to",
      "resource_name": "Person",
      "through": null
    },
    {
      "className": "PhoneNumber",
      "collectionName": "phone_numbers",
      "foreignKey": "contact_id",
      "name": "phone_numbers",
      "macro": "has_many",
      "resource_name": "PhoneNumber",
      "through": null
    },
    {
      "className": "Address",
      "collectionName": "addresses",
      "foreignKey": "address_id",
      "name": "primary_address",
      "macro": "has_one",
      "resource_name": "Address",
      "through": "primary_contact_address"
    },
    {
      "className": "BankAccount",
      "collectionName": "bank_accounts",
      "foreignKey": "contact_id",
      "name": "primary_bank_account",
      "macro": "has_one",
      "resource_name": "BankAccount",
      "through": null
    },
    {
      "className": "ContactAddress",
      "collectionName": "contact_addresses",
      "foreignKey": "contact_id",
      "name": "primary_contact_address",
      "macro": "has_one",
      "resource_name": "ContactAddress",
      "through": null
    },
    {
      "className": "Email",
      "collectionName": "emails",
      "foreignKey": "contact_id",
      "name": "primary_email",
      "macro": "has_one",
      "resource_name": "Email",
      "through": null
    },
    {
      "className": "PhoneNumber",
      "collectionName": "phone_numbers",
      "foreignKey": "contact_id",
      "name": "primary_phone_number",
      "macro": "has_one",
      "resource_name": "PhoneNumber",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "parent_id",
      "name": "region",
      "macro": "has_one",
      "resource_name": "Contact",
      "through": "region_relationship"
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "parent_id",
      "name": "relative_relationships",
      "macro": "has_many",
      "resource_name": "ContactRelationship",
      "through": null
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "school_id",
      "name": "school",
      "macro": "has_one",
      "resource_name": "Organization",
      "through": "current_school_year"
    },
    {
      "className": "SchoolYear",
      "collectionName": "school_years",
      "foreignKey": "contact_id",
      "name": "school_years",
      "macro": "has_many",
      "resource_name": "SchoolYear",
      "through": null
    },
    {
      "className": "StudentCouncil",
      "collectionName": "student_councils",
      "foreignKey": "student_council_id",
      "name": "student_council",
      "macro": "belongs_to",
      "resource_name": "StudentCouncil",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "child_id",
      "name": "student_councils",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "student_council_relationships"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "parent_id",
      "name": "student_council_for",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "student_council_for_relationships"
    },
    {
      "className": "Subscription",
      "collectionName": "subscriptions",
      "foreignKey": "contact_id",
      "name": "subscriptions",
      "macro": "has_many",
      "resource_name": "Subscription",
      "through": null
    },
    {
      "className": "Supplier",
      "collectionName": "suppliers",
      "foreignKey": "supplier_id",
      "name": "supplier",
      "macro": "belongs_to",
      "resource_name": "Supplier",
      "through": null
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "person_id",
      "name": "user",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    }
  ],
  "paramKey": "contact",
  "primaryKey": "id"
}

/** Frontend model for Contact. */
export default class Contact extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {boolean} */
  anonymize() {
    return this.readAttributeUnderscore("anonymize")
  }

  /** @returns {boolean} */
  hasAnonymize() {
    const value = this.anonymize()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  anonymizeAt() {
    return this.readAttributeUnderscore("anonymize_at")
  }

  /** @returns {boolean} */
  hasAnonymizeAt() {
    const value = this.anonymizeAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  contactType() {
    return this.readAttributeUnderscore("contact_type")
  }

  /** @returns {boolean} */
  hasContactType() {
    const value = this.contactType()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  deletedAt() {
    return this.readAttributeUnderscore("deleted_at")
  }

  /** @returns {boolean} */
  hasDeletedAt() {
    const value = this.deletedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  financeDimensionValueId() {
    return this.readAttributeUnderscore("finance_dimension_value_id")
  }

  /** @returns {boolean} */
  hasFinanceDimensionValueId() {
    const value = this.financeDimensionValueId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  organizationId() {
    return this.readAttributeUnderscore("organization_id")
  }

  /** @returns {boolean} */
  hasOrganizationId() {
    const value = this.organizationId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  personId() {
    return this.readAttributeUnderscore("person_id")
  }

  /** @returns {boolean} */
  hasPersonId() {
    const value = this.personId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {string} */
  tenantId() {
    return this.readAttributeUnderscore("tenant_id")
  }

  /** @returns {boolean} */
  hasTenantId() {
    const value = this.tenantId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  billingContactId() {
    return this.readAttributeUnderscore("billing_contact_id")
  }

  /** @returns {boolean} */
  hasBillingContactId() {
    const value = this.billingContactId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  debtorAccountNumber() {
    return this.readAttributeUnderscore("debtor_account_number")
  }

  /** @returns {boolean} */
  hasDebtorAccountNumber() {
    const value = this.debtorAccountNumber()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  debtorContactName() {
    return this.readAttributeUnderscore("debtor_contact_name")
  }

  /** @returns {boolean} */
  hasDebtorContactName() {
    const value = this.debtorContactName()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  importedFromOldNemoa() {
    return this.readAttributeUnderscore("imported_from_old_nemoa")
  }

  /** @returns {boolean} */
  hasImportedFromOldNemoa() {
    const value = this.importedFromOldNemoa()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  nemoaOldContactId() {
    return this.readAttributeUnderscore("nemoa_old_contact_id")
  }

  /** @returns {boolean} */
  hasNemoaOldContactId() {
    const value = this.nemoaOldContactId()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  nemoaOldCreatedAt() {
    return this.readAttributeUnderscore("nemoa_old_created_at")
  }

  /** @returns {boolean} */
  hasNemoaOldCreatedAt() {
    const value = this.nemoaOldCreatedAt()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  nemoaOldGlobalId() {
    return this.readAttributeUnderscore("nemoa_old_global_id")
  }

  /** @returns {boolean} */
  hasNemoaOldGlobalId() {
    const value = this.nemoaOldGlobalId()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  pNumber() {
    return this.readAttributeUnderscore("p_number")
  }

  /** @returns {boolean} */
  hasPNumber() {
    const value = this.pNumber()

    return this._isPresent(value)
  }

  /** @returns {any} */
  pNumberWithFallback() {
    return this.readAttributeUnderscore("p_number_with_fallback")
  }

  /** @returns {boolean} */
  hasPNumberWithFallback() {
    const value = this.pNumberWithFallback()

    return this._isPresent(value)
  }

  /** @returns {any} */
  departmentsWithAncestors() {
    return this.readAttributeUnderscore("departments_with_ancestors")
  }

  /** @returns {boolean} */
  hasDepartmentsWithAncestors() {
    const value = this.departmentsWithAncestors()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedContactType() {
    return this.readAttributeUnderscore("translated_contact_type")
  }

  /** @returns {boolean} */
  hasTranslatedContactType() {
    const value = this.translatedContactType()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedState() {
    return this.readAttributeUnderscore("translated_state")
  }

  /** @returns {boolean} */
  hasTranslatedState() {
    const value = this.translatedState()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static addToActivity(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "add_to_activity",
        collectionName: "contacts",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static createWithUserFromEmail(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "create_with_user_from_email",
        collectionName: "contacts",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static uniCData(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "uni_c_data",
        collectionName: "contacts",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static uploadFileAndUpdateKmdIdentifierForContacts(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "upload_file_and_update_kmd_identifier_for_contacts",
        collectionName: "contacts",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  calculatedBillingContact(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "calculated_billing_contact",
        primaryKey: this.primaryKey(),
        collectionName: "contacts",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  convertOrganizationToPerson(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "convert_organization_to_person",
        primaryKey: this.primaryKey(),
        collectionName: "contacts",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  departments(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "departments",
        primaryKey: this.primaryKey(),
        collectionName: "contacts",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  uniCOrganizationRelations(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "uni_c_organization_relations",
        primaryKey: this.primaryKey(),
        collectionName: "contacts",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  upsertInBusinessCentral(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "upsert_in_business_central",
        primaryKey: this.primaryKey(),
        collectionName: "contacts",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./address.js").default>} */
  addresses() {
    return new Collection(
      {
        reflectionName: "addresses",
        model: this,
        modelClass: Address
      },
      {
        params: {
          through: {
            model: "Contact",
            id: this.primaryKey(),
            reflection: "addresses"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./address.js").default>>} */
  loadAddresses() {
    return this._loadHasManyReflection(
      {
        reflectionName: "addresses",
        model: this,
        modelClass: Address
      },
      {
        params: {
          through: {
            model: "Contact",
            id: this.primaryKey(),
            reflection: "addresses"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./address.js").default>>} */
  ensureAddressesLoaded() {
    return this.ensureAssociationLoaded("addresses")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./bank-account.js").default>} */
  bankAccounts() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["contact_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "bank_accounts",
        model: this,
        modelClass: BankAccount
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./bank-account.js").default>>} */
  loadBankAccounts() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["contact_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "bank_accounts",
        model: this,
        modelClass: BankAccount
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./bank-account.js").default>>} */
  ensureBankAccountsLoaded() {
    return this.ensureAssociationLoaded("bank_accounts")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./contact.js").default>} */
  children() {
    return new Collection(
      {
        reflectionName: "children",
        model: this,
        modelClass: Contact
      },
      {
        params: {
          through: {
            model: "Contact",
            id: this.primaryKey(),
            reflection: "children"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./contact.js").default>>} */
  loadChildren() {
    return this._loadHasManyReflection(
      {
        reflectionName: "children",
        model: this,
        modelClass: Contact
      },
      {
        params: {
          through: {
            model: "Contact",
            id: this.primaryKey(),
            reflection: "children"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./contact.js").default>>} */
  ensureChildrenLoaded() {
    return this.ensureAssociationLoaded("children")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./contact-relationship.js").default>} */
  childrenRelationships() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["parent_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "children_relationships",
        model: this,
        modelClass: ContactRelationship
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./contact-relationship.js").default>>} */
  loadChildrenRelationships() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["parent_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "children_relationships",
        model: this,
        modelClass: ContactRelationship
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./contact-relationship.js").default>>} */
  ensureChildrenRelationshipsLoaded() {
    return this.ensureAssociationLoaded("children_relationships")
  }

  /** @returns {import("./contact.js").default | null} */
  commune() {
    return this._readHasOneReflection({modelClass: Contact, reflectionName: "commune"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadCommune() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "commune",
        model: this,
        modelClass: Contact
      },
      {
        params: {
          through: {
            model: "Contact",
            id,
            reflection: "commune"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureCommuneLoaded() {
    return this.ensureAssociationLoaded("commune")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./contact.js").default>} */
  communeFor() {
    return new Collection(
      {
        reflectionName: "commune_for",
        model: this,
        modelClass: Contact
      },
      {
        params: {
          through: {
            model: "Contact",
            id: this.primaryKey(),
            reflection: "commune_for"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./contact.js").default>>} */
  loadCommuneFor() {
    return this._loadHasManyReflection(
      {
        reflectionName: "commune_for",
        model: this,
        modelClass: Contact
      },
      {
        params: {
          through: {
            model: "Contact",
            id: this.primaryKey(),
            reflection: "commune_for"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./contact.js").default>>} */
  ensureCommuneForLoaded() {
    return this.ensureAssociationLoaded("commune_for")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./contact-address.js").default>} */
  contactAddresses() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["contact_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "contact_addresses",
        model: this,
        modelClass: ContactAddress
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./contact-address.js").default>>} */
  loadContactAddresses() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["contact_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "contact_addresses",
        model: this,
        modelClass: ContactAddress
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./contact-address.js").default>>} */
  ensureContactAddressesLoaded() {
    return this.ensureAssociationLoaded("contact_addresses")
  }

  /** @returns {import("./school-year.js").default | null} */
  currentSchoolYear() {
    return this._readHasOneReflection({modelClass: SchoolYear, reflectionName: "current_school_year"})
  }

  /** @returns {Promise<import("./school-year.js").default | null>} */
  loadCurrentSchoolYear() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["contact_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "current_school_year",
        model: this,
        modelClass: SchoolYear
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./school-year.js").default | null>} */
  ensureCurrentSchoolYearLoaded() {
    return this.ensureAssociationLoaded("current_school_year")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./email.js").default>} */
  emails() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["contact_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "emails",
        model: this,
        modelClass: Email
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./email.js").default>>} */
  loadEmails() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["contact_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "emails",
        model: this,
        modelClass: Email
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./email.js").default>>} */
  ensureEmailsLoaded() {
    return this.ensureAssociationLoaded("emails")
  }

  /** @returns {import("./contact.js").default | null} */
  jointStudentCouncil() {
    return this._readHasOneReflection({modelClass: Contact, reflectionName: "joint_student_council"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadJointStudentCouncil() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "joint_student_council",
        model: this,
        modelClass: Contact
      },
      {
        params: {
          through: {
            model: "Contact",
            id,
            reflection: "joint_student_council"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureJointStudentCouncilLoaded() {
    return this.ensureAssociationLoaded("joint_student_council")
  }

  /** @returns {import("./contact.js").default | null} */
  jointStudentCouncilFor() {
    return this._readHasOneReflection({modelClass: Contact, reflectionName: "joint_student_council_for"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadJointStudentCouncilFor() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "joint_student_council_for",
        model: this,
        modelClass: Contact
      },
      {
        params: {
          through: {
            model: "Contact",
            id,
            reflection: "joint_student_council_for"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureJointStudentCouncilForLoaded() {
    return this.ensureAssociationLoaded("joint_student_council_for")
  }

  /** @returns {import("./organization.js").default | null} */
  organization() {
    return this._readBelongsToReflection({modelClass: Organization, reflectionName: "organization"})
  }

  /** @returns {Promise<import("./organization.js").default | null>} */
  loadOrganization() {
    if (!("organizationId" in this)) throw new Error("Foreign key method wasn't defined: organizationId")

    const id = this.organizationId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "organization",
        model: this,
        modelClass: Organization
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./organization.js").default | null>} */
  ensureOrganizationLoaded() {
    return this.ensureAssociationLoaded("organization")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./contact.js").default>} */
  parents() {
    return new Collection(
      {
        reflectionName: "parents",
        model: this,
        modelClass: Contact
      },
      {
        params: {
          through: {
            model: "Contact",
            id: this.primaryKey(),
            reflection: "parents"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./contact.js").default>>} */
  loadParents() {
    return this._loadHasManyReflection(
      {
        reflectionName: "parents",
        model: this,
        modelClass: Contact
      },
      {
        params: {
          through: {
            model: "Contact",
            id: this.primaryKey(),
            reflection: "parents"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./contact.js").default>>} */
  ensureParentsLoaded() {
    return this.ensureAssociationLoaded("parents")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./contact-relationship.js").default>} */
  parentRelationships() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["child_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "parent_relationships",
        model: this,
        modelClass: ContactRelationship
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./contact-relationship.js").default>>} */
  loadParentRelationships() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["child_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "parent_relationships",
        model: this,
        modelClass: ContactRelationship
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./contact-relationship.js").default>>} */
  ensureParentRelationshipsLoaded() {
    return this.ensureAssociationLoaded("parent_relationships")
  }

  /** @returns {import("./person.js").default | null} */
  person() {
    return this._readBelongsToReflection({modelClass: Person, reflectionName: "person"})
  }

  /** @returns {Promise<import("./person.js").default | null>} */
  loadPerson() {
    if (!("personId" in this)) throw new Error("Foreign key method wasn't defined: personId")

    const id = this.personId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "person",
        model: this,
        modelClass: Person
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./person.js").default | null>} */
  ensurePersonLoaded() {
    return this.ensureAssociationLoaded("person")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./phone-number.js").default>} */
  phoneNumbers() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["contact_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "phone_numbers",
        model: this,
        modelClass: PhoneNumber
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./phone-number.js").default>>} */
  loadPhoneNumbers() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["contact_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "phone_numbers",
        model: this,
        modelClass: PhoneNumber
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./phone-number.js").default>>} */
  ensurePhoneNumbersLoaded() {
    return this.ensureAssociationLoaded("phone_numbers")
  }

  /** @returns {import("./address.js").default | null} */
  primaryAddress() {
    return this._readHasOneReflection({modelClass: Address, reflectionName: "primary_address"})
  }

  /** @returns {Promise<import("./address.js").default | null>} */
  loadPrimaryAddress() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "primary_address",
        model: this,
        modelClass: Address
      },
      {
        params: {
          through: {
            model: "Contact",
            id,
            reflection: "primary_address"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./address.js").default | null>} */
  ensurePrimaryAddressLoaded() {
    return this.ensureAssociationLoaded("primary_address")
  }

  /** @returns {import("./bank-account.js").default | null} */
  primaryBankAccount() {
    return this._readHasOneReflection({modelClass: BankAccount, reflectionName: "primary_bank_account"})
  }

  /** @returns {Promise<import("./bank-account.js").default | null>} */
  loadPrimaryBankAccount() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["contact_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "primary_bank_account",
        model: this,
        modelClass: BankAccount
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./bank-account.js").default | null>} */
  ensurePrimaryBankAccountLoaded() {
    return this.ensureAssociationLoaded("primary_bank_account")
  }

  /** @returns {import("./contact-address.js").default | null} */
  primaryContactAddress() {
    return this._readHasOneReflection({modelClass: ContactAddress, reflectionName: "primary_contact_address"})
  }

  /** @returns {Promise<import("./contact-address.js").default | null>} */
  loadPrimaryContactAddress() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["contact_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "primary_contact_address",
        model: this,
        modelClass: ContactAddress
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact-address.js").default | null>} */
  ensurePrimaryContactAddressLoaded() {
    return this.ensureAssociationLoaded("primary_contact_address")
  }

  /** @returns {import("./email.js").default | null} */
  primaryEmail() {
    return this._readHasOneReflection({modelClass: Email, reflectionName: "primary_email"})
  }

  /** @returns {Promise<import("./email.js").default | null>} */
  loadPrimaryEmail() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["contact_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "primary_email",
        model: this,
        modelClass: Email
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./email.js").default | null>} */
  ensurePrimaryEmailLoaded() {
    return this.ensureAssociationLoaded("primary_email")
  }

  /** @returns {import("./phone-number.js").default | null} */
  primaryPhoneNumber() {
    return this._readHasOneReflection({modelClass: PhoneNumber, reflectionName: "primary_phone_number"})
  }

  /** @returns {Promise<import("./phone-number.js").default | null>} */
  loadPrimaryPhoneNumber() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["contact_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "primary_phone_number",
        model: this,
        modelClass: PhoneNumber
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./phone-number.js").default | null>} */
  ensurePrimaryPhoneNumberLoaded() {
    return this.ensureAssociationLoaded("primary_phone_number")
  }

  /** @returns {import("./contact.js").default | null} */
  region() {
    return this._readHasOneReflection({modelClass: Contact, reflectionName: "region"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadRegion() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "region",
        model: this,
        modelClass: Contact
      },
      {
        params: {
          through: {
            model: "Contact",
            id,
            reflection: "region"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureRegionLoaded() {
    return this.ensureAssociationLoaded("region")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./contact-relationship.js").default>} */
  relativeRelationships() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["parent_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "relative_relationships",
        model: this,
        modelClass: ContactRelationship
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./contact-relationship.js").default>>} */
  loadRelativeRelationships() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["parent_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "relative_relationships",
        model: this,
        modelClass: ContactRelationship
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./contact-relationship.js").default>>} */
  ensureRelativeRelationshipsLoaded() {
    return this.ensureAssociationLoaded("relative_relationships")
  }

  /** @returns {import("./organization.js").default | null} */
  school() {
    return this._readHasOneReflection({modelClass: Organization, reflectionName: "school"})
  }

  /** @returns {Promise<import("./organization.js").default | null>} */
  loadSchool() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "school",
        model: this,
        modelClass: Organization
      },
      {
        params: {
          through: {
            model: "Contact",
            id,
            reflection: "school"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./organization.js").default | null>} */
  ensureSchoolLoaded() {
    return this.ensureAssociationLoaded("school")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./school-year.js").default>} */
  schoolYears() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["contact_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "school_years",
        model: this,
        modelClass: SchoolYear
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./school-year.js").default>>} */
  loadSchoolYears() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["contact_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "school_years",
        model: this,
        modelClass: SchoolYear
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./school-year.js").default>>} */
  ensureSchoolYearsLoaded() {
    return this.ensureAssociationLoaded("school_years")
  }

  /** @returns {import("./student-council.js").default | null} */
  studentCouncil() {
    return this._readBelongsToReflection({modelClass: StudentCouncil, reflectionName: "student_council"})
  }

  /** @returns {Promise<import("./student-council.js").default | null>} */
  loadStudentCouncil() {
    if (!("studentCouncilId" in this)) throw new Error("Foreign key method wasn't defined: studentCouncilId")

    const id = this.studentCouncilId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "student_council",
        model: this,
        modelClass: StudentCouncil
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./student-council.js").default | null>} */
  ensureStudentCouncilLoaded() {
    return this.ensureAssociationLoaded("student_council")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./contact.js").default>} */
  studentCouncils() {
    return new Collection(
      {
        reflectionName: "student_councils",
        model: this,
        modelClass: Contact
      },
      {
        params: {
          through: {
            model: "Contact",
            id: this.primaryKey(),
            reflection: "student_councils"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./contact.js").default>>} */
  loadStudentCouncils() {
    return this._loadHasManyReflection(
      {
        reflectionName: "student_councils",
        model: this,
        modelClass: Contact
      },
      {
        params: {
          through: {
            model: "Contact",
            id: this.primaryKey(),
            reflection: "student_councils"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./contact.js").default>>} */
  ensureStudentCouncilsLoaded() {
    return this.ensureAssociationLoaded("student_councils")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./contact.js").default>} */
  studentCouncilFor() {
    return new Collection(
      {
        reflectionName: "student_council_for",
        model: this,
        modelClass: Contact
      },
      {
        params: {
          through: {
            model: "Contact",
            id: this.primaryKey(),
            reflection: "student_council_for"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./contact.js").default>>} */
  loadStudentCouncilFor() {
    return this._loadHasManyReflection(
      {
        reflectionName: "student_council_for",
        model: this,
        modelClass: Contact
      },
      {
        params: {
          through: {
            model: "Contact",
            id: this.primaryKey(),
            reflection: "student_council_for"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./contact.js").default>>} */
  ensureStudentCouncilForLoaded() {
    return this.ensureAssociationLoaded("student_council_for")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./subscription.js").default>} */
  subscriptions() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["contact_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "subscriptions",
        model: this,
        modelClass: Subscription
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./subscription.js").default>>} */
  loadSubscriptions() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["contact_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "subscriptions",
        model: this,
        modelClass: Subscription
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./subscription.js").default>>} */
  ensureSubscriptionsLoaded() {
    return this.ensureAssociationLoaded("subscriptions")
  }

  /** @returns {import("./supplier.js").default | null} */
  supplier() {
    return this._readBelongsToReflection({modelClass: Supplier, reflectionName: "supplier"})
  }

  /** @returns {Promise<import("./supplier.js").default | null>} */
  loadSupplier() {
    if (!("supplierId" in this)) throw new Error("Foreign key method wasn't defined: supplierId")

    const id = this.supplierId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "supplier",
        model: this,
        modelClass: Supplier
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./supplier.js").default | null>} */
  ensureSupplierLoaded() {
    return this.ensureAssociationLoaded("supplier")
  }

  /** @returns {import("./tenant.js").default | null} */
  tenant() {
    return this._readBelongsToReflection({modelClass: Tenant, reflectionName: "tenant"})
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  loadTenant() {
    if (!("tenantId" in this)) throw new Error("Foreign key method wasn't defined: tenantId")

    const id = this.tenantId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "tenant",
        model: this,
        modelClass: Tenant
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  ensureTenantLoaded() {
    return this.ensureAssociationLoaded("tenant")
  }

  /** @returns {import("./user.js").default | null} */
  user() {
    return this._readBelongsToReflection({modelClass: User, reflectionName: "user"})
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  loadUser() {
    if (!("personId" in this)) throw new Error("Foreign key method wasn't defined: personId")

    const id = this.personId()
    const ransack = {}

    ransack["person_id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "user",
        model: this,
        modelClass: User
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  ensureUserLoaded() {
    return this.ensureAssociationLoaded("user")
  }
}
